import { put, takeLatest } from 'redux-saga/effects'
import * as dashboardModule from '../modules/dashboard'
import { submitForReview } from '../api'

function* submitForReviewSaga({ meta }) {
  try {
    const response = yield submitForReview(meta.candidateId)

    //Trigger GTM Event when candidate is submitted for review from Candidate dashboard
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Candidate Submit',
      action: 'submitted for review',
      label: 'offerzen core',
      source: 'reapply',
      source_detail: 'candidate dashboard',
    })

    yield put(dashboardModule.submitForReviewSuccess(response))
  } catch (err) { }
}

export default function* watchDashboardSaga() {
  yield takeLatest(dashboardModule.SUBMIT_FOR_REVIEW, submitForReviewSaga)
}
